import React, {Component} from 'react';
import {Modal, Button}  from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSyncAlt} from  '@fortawesome/free-solid-svg-icons';

import {fetchSourceDevices} from '../../database/fetch'
import {Uncommissioned, Commissioned} from '../Model/Uncommissioned'
import SecondServer from '../../database/SecondServer'
import DeviceCombo from './Combobox'
import { renderLoader } from '../../Loading/loading';

import '../report-header.css'
import '../../commoninputs.css'
import './Swapdevice.css'

export default class SwapDevice extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      uncomm: undefined,
      comm: undefined,
      deviceId: "",
      errMsg: null,
      isLoading: false,
      loader: renderLoader(),
    }
    this.handleClose = this.handleClose.bind(this);
    this.swapContent = this.swapContent.bind(this);
    this.deviceId = this.deviceId.bind(this)
  }
  async componentDidMount() {
    const apiResp = await this.fetchData()
    const arrUncomm = Uncommissioned(apiResp)
    const arrComm = Commissioned(apiResp)
    const displayList = Array.isArray (arrUncomm) ? arrUncomm.map(item=>item.device_id) : undefined
    const displayComm = Array.isArray(arrComm) ? arrComm.map(item=>item.device_id) : undefined
    this.setState({uncomm: displayList, comm: displayComm})
  }
  async componentDidUpdate(prevProps) {
    if (this.props.show && prevProps.show !== this.props.show)
      this.setState ({errMsg: "", isLoading: false})
  }
  async fetchData() {
    if ('function' === typeof this.props.getActiveSite) {
      const site = this.props.getActiveSite();
      const ss = new SecondServer(this.props);
      const jsonResponse = await fetchSourceDevices (site, ss)
      this.setState ( {errorMsg: ss.getErrorMsg() } );
      return jsonResponse
    }
  }

  validateDevice () {
    const re = /^[0-9A-Fa-f]{8}$/;
    if (!re.test(this.state.deviceId)) {
      this.setState ({errMsg: "Replacement device id must be 8 characters (0-9 or A-F)"})
      return false;
    }
    else {
      this.setState({errMsg: null})
      return true
    }
  }
  handleClose(event) {
    const swapWanted = event?.target?.id === 'ok'
    if (!swapWanted || this.props.devices.length !== 1) {
      this.props.onHide(false)
      return
    }
    if (this.validateDevice()) {
      const comm = this.props?.isCommissioned && this.props.isCommissioned(this.state.deviceId)
      if (comm) {
        this.setState({errMsg: "Cannot swap in an already commissioned device"})
        return
      }
      if (typeof this.props.onHide === 'function')
        this.setState ({isLoading: true})
        this.props.onHide(swapWanted, this.state.deviceId, this.state.uncomm.includes(this.state.deviceId));
    }
  }
  selectFirst () {
    return ("On the page, check the box next to a device you would like to swap out.")
  }
  selectOne() {
    return ("There are multiple devices selected on the main page. Please pick just one")
  }
  noDCAPS() {
    return ("Swapping DCAPS is not yet supported. Please pick any other device")
  }
  renderModal (bodyContent) {
    return(
      <Modal show={this.props.show ?? false} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Swap Device</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bodyContent()}
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" id='cancel' onClick={this.handleClose} disabled={this.state.isLoading}>Cancel</Button>
          <span>&nbsp;</span>
          <Button className="custom-std-btn" id='ok' onClick={this.handleClose} disabled={this.state.isLoading}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }
  deviceId (newValue) {
    this.setState({deviceId: newValue})
  }
  swapContent () {
    if (this.state.isLoading)
      return this.state.loader
    const startDevice = this.props?.devices?.length === 1 ? this.props?.devices[0]?.device_id : ""
    const swapOrder = this.props?.swapOrder === "1"
    const uncomms = swapOrder ? this.state.comm??[] : this.state.uncomm??[]
    const lbl = swapOrder ? 'Replace': 'Replacement device id'
    const p1 = <span className="swapChosen">{swapOrder?"New":"Old"} Device {startDevice}</span>
    const p2 = <DeviceCombo options={uncomms} onChange={this.deviceId} label={lbl}/>
    return swapOrder ? this.renderSwap(p2, p1) : this.renderSwap(p1, p2)
  }
  
  renderSwap(col1, col3) {
    return (
      <div className="swapwrapper">
        <div className="swapone">{col1}</div>
        <div className="swaptwo"><FontAwesomeIcon icon={faSyncAlt} color='#444' size="3x" /></div>
        <div className="swapthree">{col3}</div> 
      </div>
    )
  }
  render() {
    const dev  = this.props?.devices
    if (!Array.isArray(dev) || dev.length === 0)
      return this.renderModal(this.selectFirst);

    if (dev.length > 1)
      return (this.renderModal(this.selectOne));

    if (dev[0]?.type && dev[0].type.includes("DCAP"))
      return this.renderModal(this.noDCAPS)
  
    return(this.renderModal(this.swapContent))
  }
}  